"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NftService = void 0;
var nft_1 = require("./firmachain/nft");
var FirmaUtil_1 = require("./FirmaUtil");
var NftService = /** @class */ (function () {
    function NftService(config) {
        this.config = config;
    }
    NftService.prototype.getNftItemAll = function (paginationKey) {
        if (paginationKey === void 0) { paginationKey = ""; }
        return __awaiter(this, void 0, void 0, function () {
            var nftQueryClient, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        nftQueryClient = new nft_1.NftQueryClient(this.config.restApiAddress);
                        return [4 /*yield*/, nftQueryClient.queryNftItemAll(paginationKey)];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        error_1 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_1);
                        throw error_1;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    NftService.prototype.getNftItem = function (nftId) {
        return __awaiter(this, void 0, void 0, function () {
            var nftQueryClient, nftItem, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        nftQueryClient = new nft_1.NftQueryClient(this.config.restApiAddress);
                        return [4 /*yield*/, nftQueryClient.queryNftItem(nftId)];
                    case 1:
                        nftItem = _a.sent();
                        return [2 /*return*/, nftItem];
                    case 2:
                        error_2 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_2);
                        throw error_2;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    NftService.prototype.getNftItemAllFromAddress = function (ownerAddress, paginationKey) {
        if (paginationKey === void 0) { paginationKey = ""; }
        return __awaiter(this, void 0, void 0, function () {
            var result, nftItemList, nftQueryClient, i, nftItem, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 6, , 7]);
                        return [4 /*yield*/, this.getNftIdListOfOwner(ownerAddress, paginationKey)];
                    case 1:
                        result = _a.sent();
                        nftItemList = [];
                        nftQueryClient = new nft_1.NftQueryClient(this.config.restApiAddress);
                        i = 0;
                        _a.label = 2;
                    case 2:
                        if (!(i < result.nftIdList.length)) return [3 /*break*/, 5];
                        return [4 /*yield*/, nftQueryClient.queryNftItem(result.nftIdList[i])];
                    case 3:
                        nftItem = _a.sent();
                        nftItemList.push(nftItem);
                        _a.label = 4;
                    case 4:
                        i++;
                        return [3 /*break*/, 2];
                    case 5: return [2 /*return*/, { dataList: nftItemList, pagination: { next_key: result.pagination.next_key, total: result.pagination.total } }];
                    case 6:
                        error_3 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_3);
                        throw error_3;
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    NftService.prototype.getNftIdListOfOwner = function (ownerAddress, paginationKey) {
        if (paginationKey === void 0) { paginationKey = ""; }
        return __awaiter(this, void 0, void 0, function () {
            var nftQueryClient, error_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        nftQueryClient = new nft_1.NftQueryClient(this.config.restApiAddress);
                        return [4 /*yield*/, nftQueryClient.queryNftIdListOfOwner(ownerAddress, paginationKey)];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        error_4 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_4);
                        throw error_4;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    NftService.prototype.getBalanceOf = function (ownerAddress) {
        return __awaiter(this, void 0, void 0, function () {
            var nftQueryClient, total, error_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        nftQueryClient = new nft_1.NftQueryClient(this.config.restApiAddress);
                        return [4 /*yield*/, nftQueryClient.queryBalanceOf(ownerAddress)];
                    case 1:
                        total = _a.sent();
                        return [2 /*return*/, parseInt(total)];
                    case 2:
                        error_5 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_5);
                        throw error_5;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    NftService.prototype.getGasEstimationTransfer = function (wallet, toAddress, nftID, txMisc) {
        if (txMisc === void 0) { txMisc = FirmaUtil_1.DefaultTxMisc; }
        return __awaiter(this, void 0, void 0, function () {
            var txRaw, error_6;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this.getSignedTxTransfer(wallet, toAddress, nftID, txMisc)];
                    case 1:
                        txRaw = _a.sent();
                        return [4 /*yield*/, FirmaUtil_1.FirmaUtil.estimateGas(txRaw)];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        error_6 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_6);
                        throw error_6;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    NftService.prototype.getUnsignedTxTransfer = function (wallet, toAddress, nftID) {
        return __awaiter(this, void 0, void 0, function () {
            var address, message, error_7;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, wallet.getAddress()];
                    case 1:
                        address = _a.sent();
                        message = nft_1.NftTxClient.msgTransfer({ owner: address, toAddress: toAddress, nftId: parseInt(nftID) });
                        return [2 /*return*/, message];
                    case 2:
                        error_7 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_7);
                        throw error_7;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    NftService.prototype.getSignedTxTransfer = function (wallet, toAddress, nftID, txMisc) {
        if (txMisc === void 0) { txMisc = FirmaUtil_1.DefaultTxMisc; }
        return __awaiter(this, void 0, void 0, function () {
            var message, nftTxClient, error_8;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this.getUnsignedTxTransfer(wallet, toAddress, nftID)];
                    case 1:
                        message = _a.sent();
                        nftTxClient = new nft_1.NftTxClient(wallet, this.config.rpcAddress);
                        return [4 /*yield*/, nftTxClient.sign([message], FirmaUtil_1.getSignAndBroadcastOption(this.config.denom, txMisc))];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        error_8 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_8);
                        throw error_8;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    NftService.prototype.transfer = function (wallet, toAddress, nftID, txMisc) {
        if (txMisc === void 0) { txMisc = FirmaUtil_1.DefaultTxMisc; }
        return __awaiter(this, void 0, void 0, function () {
            var txRaw, nftTxClient, error_9;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this.getSignedTxTransfer(wallet, toAddress, nftID, txMisc)];
                    case 1:
                        txRaw = _a.sent();
                        nftTxClient = new nft_1.NftTxClient(wallet, this.config.rpcAddress);
                        return [4 /*yield*/, nftTxClient.broadcast(txRaw)];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        error_9 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_9);
                        throw error_9;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    NftService.prototype.getGasEstimationBurn = function (wallet, nftID, txMisc) {
        if (txMisc === void 0) { txMisc = FirmaUtil_1.DefaultTxMisc; }
        return __awaiter(this, void 0, void 0, function () {
            var txRaw, error_10;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this.getSignedTxBurn(wallet, nftID, txMisc)];
                    case 1:
                        txRaw = _a.sent();
                        return [4 /*yield*/, FirmaUtil_1.FirmaUtil.estimateGas(txRaw)];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        error_10 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_10);
                        throw error_10;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    NftService.prototype.getUnsignedTxBurn = function (wallet, nftID) {
        return __awaiter(this, void 0, void 0, function () {
            var address, message, error_11;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, wallet.getAddress()];
                    case 1:
                        address = _a.sent();
                        message = nft_1.NftTxClient.msgBurn({ owner: address, nftId: parseInt(nftID) });
                        return [2 /*return*/, message];
                    case 2:
                        error_11 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_11);
                        throw error_11;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    NftService.prototype.getSignedTxBurn = function (wallet, nftID, txMisc) {
        if (txMisc === void 0) { txMisc = FirmaUtil_1.DefaultTxMisc; }
        return __awaiter(this, void 0, void 0, function () {
            var message, nftTxClient, error_12;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this.getUnsignedTxBurn(wallet, nftID)];
                    case 1:
                        message = _a.sent();
                        nftTxClient = new nft_1.NftTxClient(wallet, this.config.rpcAddress);
                        return [4 /*yield*/, nftTxClient.sign([message], FirmaUtil_1.getSignAndBroadcastOption(this.config.denom, txMisc))];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        error_12 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_12);
                        throw error_12;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    NftService.prototype.burn = function (wallet, nftID, txMisc) {
        if (txMisc === void 0) { txMisc = FirmaUtil_1.DefaultTxMisc; }
        return __awaiter(this, void 0, void 0, function () {
            var txRaw, nftTxClient, error_13;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this.getSignedTxBurn(wallet, nftID, txMisc)];
                    case 1:
                        txRaw = _a.sent();
                        nftTxClient = new nft_1.NftTxClient(wallet, this.config.rpcAddress);
                        return [4 /*yield*/, nftTxClient.broadcast(txRaw)];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        error_13 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_13);
                        throw error_13;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    NftService.prototype.getGasEstimationFromEncodeObject = function (wallet, msgList, txMisc) {
        if (txMisc === void 0) { txMisc = FirmaUtil_1.DefaultTxMisc; }
        return __awaiter(this, void 0, void 0, function () {
            var nftTxClient, txRaw, error_14;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        nftTxClient = new nft_1.NftTxClient(wallet, this.config.rpcAddress);
                        return [4 /*yield*/, nftTxClient.sign(msgList, FirmaUtil_1.getSignAndBroadcastOption(this.config.denom, txMisc))];
                    case 1:
                        txRaw = _a.sent();
                        return [4 /*yield*/, FirmaUtil_1.FirmaUtil.estimateGas(txRaw)];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        error_14 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_14);
                        throw error_14;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    NftService.prototype.getGasEstimationMint = function (wallet, tokenURI, txMisc) {
        if (txMisc === void 0) { txMisc = FirmaUtil_1.DefaultTxMisc; }
        return __awaiter(this, void 0, void 0, function () {
            var txRaw, error_15;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this.getSignedTxMint(wallet, tokenURI, txMisc)];
                    case 1:
                        txRaw = _a.sent();
                        return [4 /*yield*/, FirmaUtil_1.FirmaUtil.estimateGas(txRaw)];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        error_15 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_15);
                        throw error_15;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    NftService.prototype.getSignedTxMint = function (wallet, tokenURI, txMisc) {
        if (txMisc === void 0) { txMisc = FirmaUtil_1.DefaultTxMisc; }
        return __awaiter(this, void 0, void 0, function () {
            var message, nftTxClient, error_16;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this.getUnsignedTxMint(wallet, tokenURI)];
                    case 1:
                        message = _a.sent();
                        nftTxClient = new nft_1.NftTxClient(wallet, this.config.rpcAddress);
                        return [4 /*yield*/, nftTxClient.sign([message], FirmaUtil_1.getSignAndBroadcastOption(this.config.denom, txMisc))];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        error_16 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_16);
                        throw error_16;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    NftService.prototype.getUnsignedTxMint = function (wallet, tokenURI) {
        return __awaiter(this, void 0, void 0, function () {
            var address, message, error_17;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, wallet.getAddress()];
                    case 1:
                        address = _a.sent();
                        message = nft_1.NftTxClient.msgMint({ owner: address, tokenURI: tokenURI });
                        return [2 /*return*/, message];
                    case 2:
                        error_17 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_17);
                        throw error_17;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    NftService.prototype.mint = function (wallet, tokenURI, txMisc) {
        if (txMisc === void 0) { txMisc = FirmaUtil_1.DefaultTxMisc; }
        return __awaiter(this, void 0, void 0, function () {
            var txRaw, nftTxClient, error_18;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this.getSignedTxMint(wallet, tokenURI, txMisc)];
                    case 1:
                        txRaw = _a.sent();
                        nftTxClient = new nft_1.NftTxClient(wallet, this.config.rpcAddress);
                        return [4 /*yield*/, nftTxClient.broadcast(txRaw)];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        error_18 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_18);
                        throw error_18;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    NftService.prototype.signAndBroadcast = function (wallet, msgList, txMisc) {
        if (txMisc === void 0) { txMisc = FirmaUtil_1.DefaultTxMisc; }
        return __awaiter(this, void 0, void 0, function () {
            var contractTxClient, error_19;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        contractTxClient = new nft_1.NftTxClient(wallet, this.config.rpcAddress);
                        return [4 /*yield*/, contractTxClient.signAndBroadcast(msgList, FirmaUtil_1.getSignAndBroadcastOption(this.config.denom, txMisc))];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        error_19 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_19);
                        throw error_19;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    return NftService;
}());
exports.NftService = NftService;
